import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import {
  MAXIMUM_VALUE,
  MINIMUM_VALUE,
  MIN_LENGTH_PASSWORD,
  OPERATORS_FILTERS
} from "./GeneralConstants";
import { FORM_CATEGORY } from "@/modules/FormTemplate/constants/FormTemplateConstants";

export const FORM_CONSTANTS = {
  PAGE_TITLE: "Neumomed",
  SEARCH_TEXT: "Buscar por ",
  PREVIEW_TEXT: "Vista previa",
  MOBILE_STYLE: "margin-left: auto; margin-right: auto; width: ",
  PANEL_VIEW: "Cambiar vista panel",
  BUTTON: {
    SEND: "Enviar",
    SAVE: "Guardar",
    CANCEL: "Cancelar",
    CLOSE: "Cerrar",
    ACCEPT: "Aceptar",
    EDIT: "Editar",
    GO_BACK: "Volver",
    ADD: "Agregar",
    ADDED: "Agregado",
    SEARCH: "Buscar",
    CLEAN_FILTER: "X Filtros",
    CLOSE_SESSION: "Cerrar sesión",
    VIEW: "Ver",
    DELETE: "Eliminar",
    MORE_INFO: "Más información",
    PREVIEW: "Visualizar",
    ADD_CONDITION: "Agregar condicion",
    PAGE_START: "Ir al inicio",
    LISTEN: "Escuchar",
    DUPLICATE: "Duplicar"
  },
  LABEL: {
    MOBILE_PREVIEW: "Activar vista móvil",
    STATE: "Activo",
    FIELD_WIDTH: "Ancho de campo",
    IS_CATEGORY: "¿Es categoría?",
    IS_CATEGORY_DOCUMENTS: "¿Es categoría de documentos?",
    PRIOR_ORDER: "Orden previa",
    COPY_FORM: "Copiar formulario",
    ADD_FORM: "Agregar formulario",
    PARTIAL_SAVE: "Guardado parcial"
  },
  ICONS_URL: "http://code.meta-platform.com/assets/mdi/preview.html",
  MENU_BAR: {
    FORMS: "Formularios",
    SERVICES: "Servicios",
    USERS: "Usuarios",
    PATIENTS: "Pacientes",
    ORDERS: "Órdenes",
    ADMIN: "Tablero administrativo",
    SCHEDULING: "Agendamiento",
    SESSIONS: "Sesiones",
    TASKS: "Tareas",
    RULES: "Reglas",
    OPTIONS: {
      SEARCH_LISTS: "Consultar listas",
      ADD_LIST: "Agregar Lista",
      SEARCH_FORM_TEMPS: "Consultar formularios",
      EDIT_ORDER_TEMP: "Editar plantilla órdenes",
      SEARCH_PATIENTS: "Consultar pacientes",
      SEARCH_PRICE_LVLS: "Consultar nivel de precio",
      SEARCH_SPACES: "Consultar espacios",
      SEARCH_SESSION_TEMPS: "Consultar sesiones",
      SEARCH_SERVICE_TEMPS: "Consultar servicios",
      SEARCH_INFO_GROUP: "Consultar grupo de información",
      SEARCH_USER_TEMPS: "Consultar plantillas de usuarios",
      SEARCH_ROLES: "Consultar roles",
      SEARCH_USERS: "Consultar usuarios",
      ADD_MEDICAL_ORDER: "Crear orden",
      LOAD_ORDERS: "Cargar Órdenes",
      SEARCH_CAMPUS: "Consultar sedes",
      SEARCH_DEPENDENCIES: "Consultar dependencias",
      AVAILABILITY: "Consultar disponibilidades"
    }
  },
  APP_BAR: {
    OPTIONS: {
      MY_CALENDAR: "Mi agenda",
      LOG_OUT: "Cerrar sesión"
    }
  },
  TOOLTIP: {
    DELETE_FILTER: "Eliminar filtros"
  },
  GLOBAL_VARS: {
    SERVICE_WORKER: "serviceWorker",
    PUSH_MANAGER: "PushManager"
  },
  SNACKBAR_MESSAGES: {
    DELETE_REASONS_NOT_FOUND:
      "Error al cargar la lista de razones de eliminación",
    ADD_CONDITION_ERROR: "Ya existe una condición para ese campo",
    AT_LEAST_ONE_SERVICE: "Debe agregar al menos un servicio",
    AT_LEAST_ONE_USER: "Debe agregar al menos un usuario",
    CAMPUS_EMPTY: "Debe seleccionar la sede.",
    FORM_COULD_NOT_DELETE:
      "Este formulario está siendo usado, no se puede eliminar"
  },
  SNACKBAR_EVENT: "SnackData",
  SEARCH_EVENT: "searchClicked",
  UID_TEXT: "UID",
  PREFERRED_COUNTRIES: ["CO"],
  FILTER: "Filtrar por:",
  STATE: {
    ACTIVE: "Activo",
    INACTIVE: "Inactivo",
    COMPLETE: "Completo",
    DELETED: "Eliminado"
  },
  NO_NOTIFICATIONS: "No tiene notificaciones",
  DISABLE_CONDITIONS: ["Todos", "Habilitado", "Deshabilitado"],
  CONDITION: "Condición: ",
  DISABLED_TEXT: "Deshabilitado",
  ENABLE_TEXT: "Habilitar",
  DISABLE_TEXT: "Deshabilitar",
  ENABLE_DISABLE: "Habilitar/Deshabilitar",
  ACTIVE_TEXT: "Activar",
  DEACTIVED_TEXT: "Desactivar"
};

export const FORM_MESSAGES = {
  EVENT_BUTTON: { CLOSE: "onClose", CLOSE_MODAL: "onCloseModal" },
  WHATSAPP_DUPLICATE: "No se puede seleccionar más de un canal de WhatsApp",
  NEW_REASON: "Nuevo motivo",
  NEW_REASON_TEXT: "Escribe un nuevo motivo:",
  SELECT_OPTION: "Seleccione una opción",
  REQUIRED_FIELD: "Obligatorio",
  REQUIRED_NATURAL_NUMBER_FIELD: "No se permiten números decimales.",
  FORM_ERRORS: "Por favor corrija los errores e intente nuevamente.",
  INVALID_FORMAT: "Formato inválido.",
  FORBIDDEN_REQUEST: "Acceso denegado, no tiene permiso para ",
  REQUEST_FAILED: "Ha ocurrido un error, intente más tarde.",
  DELETE: "Formulario Eliminado.",
  RESET_TEXT: "Resetear",
  NOT_FOUND: "No se encontraron plantillas de usuario.",
  NOT_FOUND_TEMPLATES: "No se encontraron plantillas de formularios.",
  COMPONENT: "{{component}}",
  NAME_COMPONENT: "{{nameComponent}}",
  TASK_WITHOUT_TO:
    "No puede configurar una tarea sin seleccionar un destinatario",
  ERROR: {
    TITLE: "Error",
    TEXT: "No puede configurar una notificación sin seleccionar un destinatario"
  },
  ACTIVED_MODAL: {
    ID: "ACTIVED_MODAL",
    TITLE: "Activar",
    TEXT:
      '¿Esta Seguro que desea activar {{component}} <strong>"{{nameComponent}}"</strong>?',
    ANSWER: "",
    TEXT_ACCEPT: "Activar"
  },
  DESACTIVED_MODAL: {
    ID: "DESACTIVED_MODAL",
    TITLE: "Desactivar",
    TEXT:
      '¿Esta Seguro que desea desactivar {{component}} <strong>"{{nameComponent}}"</strong>?',
    ANSWER: "false",
    TEXT_ACCEPT: "Desactivar"
  },
  SEND_MODAL: {
    TITLE: "Enviar",
    MESSAGE: "¿Está seguro que desea Enviar?"
  },
  SAVE_MODAL: {
    ID: "SAVE_MODAL",
    TITLE: "Guardar",
    TEXT: "¿Esta Seguro que desea Guardar {{component}}?",
    TEXT_ACCEPT: "Aceptar",
    MESSAGE: "¿Está seguro que desea Guardar?",
    WARNING:
      '<p style="color:#F1C40F"><i class="mdi mdi-alert"></i><b>Nota:</b> Si no se configura una regla con facturación, no podrá crear el servicio sin una orden asociada</p>'
  },
  UPDATE_MODAL: {
    TITLE: "Actualizar",
    TEXT: "¿Está seguro que desea Actualizar?"
  },
  DISABLED_MODAL: {
    ID: "DISABLED_MODAL",
    TITLE: "Deshabilitar",
    MESSAGE: "¿Está seguro que desea deshabilitar {{component}}?",
    TEXT: "¿Esta Seguro que desea Deshabilitar {{component}}?",
    TEXT_ACCEPT: "Deshabilitar"
  },
  CANCEL_MODAL: {
    ID: "CANCEL_MODAL",
    TITLE: "Cancelar",
    MESSAGE: "¿Está seguro que desea Cancelar?",
    TEXT: "¿Está seguro que desea Cancelar {{component}}?",
    TEXT_ACCEPT: ""
  },
  DELETE_MODAL: {
    ID: "DELETE_MODAL",
    TITLE: "Eliminar",
    MESSAGE: "¿Está seguro que desea Eliminar?",
    TEXT:
      '¿Esta Seguro que desea Eliminar {{component}} <strong>"{{nameComponent}}"</strong>?',
    TEXT_ACCEPT: "Eliminar"
  },
  CHANGE_MODAL: {
    ID: "CHANGE_MODAL",
    TITLE: "Cambiar",
    MESSAGE: "¿Está seguro que desea cambiar de elemento?",
    TEXT:
      '¿Está seguro que desea cambiar {{component}} a <strong>"{{nameComponent}}"</strong>?',
    TEXT_ACCEPT: "Cambiar"
  },
  RESET_MODAL: {
    TITLE: "Resetear",
    MESSAGE: "¿Está seguro que desea resetear?"
  },
  INFO_MESSAGE: {
    ERROR_DATA: "No se pudo traer la información",
    NO_ADITIONAL_DATA: "No hay más datos adicionales",
    NO_INFO_TO_SHOW: "No hay información para mostrar",
    EMPTY_STATE_TEXT:
      "Ingresa una palabra en la barra de búsqueda para encontrar la información que necesitas",
    INFO_TITLE: "Resultado envio de notificación"
  },
  FORM_TEMPLATE_REASON_MODAL: {
    TITLE: "Eliminar formulario",
    MESSAGE: "Ingrese la razón por la cual va a deshabilitar el formulario: "
  },
  ROLE_REASON_MODAL: {
    TITLE: "Eliminar role",
    MESSAGE: "Ingrese la razón por la cual va a eliminar el role: "
  },
  DELETE_RULE: {
    TITLE: "Eliminar regla",
    MESSAGE: "¿Está seguro que desea eliminar la regla?"
  },
  NOT_USED_DOCUMENT:
    "En base de datos no hay documentos que usen como referencia este elemento, ¿Desea continuar con la eliminación definitiva?",
  DELETE_CONDITION_MESSAGE:
    " <b>¿Está seguro de eliminar la condición?</b> <br/> Al eliminar una condición se eliminarán los campos asociados a ella.",
  DELETE_CONDITION_TITLE: "Eliminar Condición",
  DELETE_FIELD_MESSAGE:
    " <b>¿Está seguro de eliminar el campo?</b> <br/> Al eliminar un campo se eliminarán las condiciones asociadas a el.",
  DELETE_FIELD_TITLE: "Eliminar Campo",
  MAX_VALUE_LOWER_THAN_LOWER_VALUE:
    "El valor máximo debe ser mayor que el valor minimo.",
  BLANK_SPACES_WARNING: "El cuadro de texto no puede ser un espacio en blanco.",
  GREATER_THAN_ZERO: "El número debe ser mayor o igual a cero",
  FETCH_SERVICE_TEMPLATES: "fetchServiceTemplates",
  FETCH_INFO_GROUPS: "fetchInfoGroups",
  RANGE_CONDITION: {
    OUT_RANGE: "El valor se encuentra fuera del rango",
    CONDITION_DENIED: "Valor denegado, valor corecto mas cercano es {{valor}}"
  },
  DUPLICATE_RULE: {
    ID: "DUPLICATE_RULE",
    TITLE: "Duplicar",
    MESSAGE: "¿Está seguro que desea duplicar la regla?",
    TEXT:
      '¿Está seguro que desea duplicar {{component}} <strong>"{{nameComponent}}"</strong>?',
    TEXT_ACCEPT: "Duplicar"
  },
  SMS_LIMIT_EXCEEDED: {
    TITLE: "SMS Excedido",
    ERROR: "Limite de caracteres excedido",
    MESSAGE:
      "El numero de caracteres permitido para SMS es de 160 \n ¿Está seguro que desea enviar el mensaje? \n (Sera enviado a todos los canales EXCEPTO SMS)"
  },
  WHATSAPP_SESSION_CHANGED: {
    TITLE: "Paciente desconectado",
    MESSAGE:
      "El paciente se ha desconectado, por favor utilice una plantilla de Whatsapp"
  },
  SESSION_TEMPLATE_NAME_MAX_LIMIT:
    "El Nombre de la sesion debe ser menor a 80 caracteres",
  QUERY_WITH_ERRORS: "La consulta se realizó con errores"
};

export const LIST_DATA_EVENTS = {
  EDIT_DATA: "editData",
  DELETE_DATA: "deleteData",
  DELETE_VALID_DATA: "deleteValidData",
  VIEW_DATA: "viewData",
  ASSIGN_SERVICE: "assignService",
  INFO_MODAL_TEMPLATE_CLOSE: "infoModalTemplateClose",
  PROFILE: "profile",
  DISABLE_DATA: "disableData",
  ACTIVE_DESACTIVED_DATA: "activeDeactivatedData",
  DESACTIVED_DATA: "deactivatedData",
  ACTIVE_DATA: "activeData",
  CANCEL_DATA: "cancelData",
  SAVE_DATA: "saveData",
  CAN_EDIT_DATA: "editData",
  COMPLETE_APPOINTMENT: "completeAppointment",
  LISTEN_AUDIO: "listenAudio",
  ON_CLICK: "onClick",
  DUPLICATE_DATA: "duplicateData"
};

export const COMPONENT_NAME_MODAL = {
  AVAILABILITY: "la disponibilidad",
  CAMPUS: "la sede",
  CUPS_PRICE_LEVEL: "el nivel de precio",
  DEPENDENCY: "la dependencia",
  FORM_TEMPLATE: "el formulario",
  INFO_GROUP: "el grupo",
  LIST: "la lista",
  ROLE: "el rol",
  SERVICE_TEMPLATE: "el servicio",
  SESSION_TEMPLATE: "la sesion",
  SPACE: "el espacio",
  USER: "el usuario",
  USER_TEMPLATE: "la plantilla de usuario",
  NOTIFIVATION_TEMPLATE: "la plantilla de notificacion",
  APPOINTMENT: "la cita",
  TASK: "la tarea",
  RULE: "la regla",
  TEMPLATE_PDF: "Plantillas PDF",
  MULTIMEDIA: "el archivo",
  ACTION_PLAN: "el plan de acción"
};

export const STRING_PATTERN = /^[a-zA-zá-úÁ-Úñ ]*$/;
// eslint-disable-next-line no-useless-escape
export const ALPHANUMERIC_PATTERN = /^[a-zA-ZñÑ0-9 !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
export const EMAIL_PATTERN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/;
export const URL_PATTERN = /^[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)*$/;
export const NUMBER_PATTERN = /^[0-9]*$/;
export const DECIMAL_NUMBER = /^\d+([.,]\d+){0,1}$/;

/**
 * Counts "logical" form fields: one text/number/hidden input = 1;
 * all radios with the same name = 1; all checkboxes with the same name = 1.
 * Optional `data-html-group="mismo-id"`: any inputs/selects/textareas sharing
 * the same value count as ONE field (e.g. several checkboxes with different
 * `name` but one group for validation).
 */
function countLogicalHtmlFormControls(container: HTMLElement): number {
  const elements = container.querySelectorAll("input, select, textarea");
  let count = 0;
  const seenHtmlGroups = new Set<string>();
  const seenRadioNames = new Set<string>();
  const seenCheckboxNames = new Set<string>();

  elements.forEach(el => {
    const htmlGroup = el.getAttribute("data-html-group")?.trim();
    if (htmlGroup) {
      if (seenHtmlGroups.has(htmlGroup)) return;
      seenHtmlGroups.add(htmlGroup);
      count++;
      return;
    }

    if (el.tagName === "SELECT" || el.tagName === "TEXTAREA") {
      count++;
      return;
    }
    if (el.tagName !== "INPUT") return;
    const input = el as HTMLInputElement;
    const type = (input.type || "text").toLowerCase();

    if (type === "radio") {
      const name = input.name?.trim();
      if (!name) {
        count++;
        return;
      }
      if (seenRadioNames.has(name)) return;
      seenRadioNames.add(name);
      count++;
      return;
    }
    if (type === "checkbox") {
      const name = input.name?.trim();
      if (!name) {
        count++;
        return;
      }
      if (seenCheckboxNames.has(name)) return;
      seenCheckboxNames.add(name);
      count++;
      return;
    }
    count++;
  });

  return count;
}

export const FORM_VALIDATORS = {
  REQUIRED_FIELD: (v: string | number) =>
    (v !== "" && v !== undefined) || FORM_MESSAGES.REQUIRED_FIELD,
  REQUIRED_FILE: (v: File) => !!v.name || FORM_MESSAGES.REQUIRED_FIELD,
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  REQUIRED_OBJECT: (v: any) => !!v || FORM_MESSAGES.REQUIRED_FIELD,
  REQUIRED_OBJECT_FILLED: (v: any) =>
    !(Object.keys(v).length == 0) || FORM_MESSAGES.REQUIRED_FIELD,
  REQUIRED_ARRAY: (v: Array<any>) => {
    if (v instanceof Array && v.length === 0) {
      return FORM_MESSAGES.REQUIRED_FIELD;
    }

    return !!v || FORM_MESSAGES.REQUIRED_FIELD;
  },
  REQUIRED_MULTIMEDIA_OBJECT: (v: any) => {
    if (v instanceof Object && v._key === "") {
      return FORM_MESSAGES.REQUIRED_FIELD;
    }
    return !!v || FORM_MESSAGES.REQUIRED_FIELD;
  },
  REQUIRED_LIST: (v: any) => {
    if (v instanceof Object && v.id === "") {
      return FORM_MESSAGES.REQUIRED_FIELD;
    }
    return !!v || FORM_MESSAGES.REQUIRED_FIELD;
  },
  NO_REQUIRED_LIST: () => {
    return true;
  },
  URL_PATTERN: (v: string) =>
    v.length > 0 ? URL_PATTERN.test(v) || FORM_MESSAGES.INVALID_FORMAT : true,
  ALPHANUMERIC_PATTERN: (v: string) =>
    v.length > 0
      ? ALPHANUMERIC_PATTERN.test(v) || FORM_MESSAGES.INVALID_FORMAT
      : true,
  EMAIL_FIELD: (v: string) =>
    v.length > 0 ? EMAIL_PATTERN.test(v) || FORM_MESSAGES.INVALID_FORMAT : true,
  NUMBER_FIELD: (v: string) =>
    v != undefined && v.length > 0
      ? NUMBER_PATTERN.test(v) || FORM_MESSAGES.INVALID_FORMAT
      : true,
  NOT_BLANK_SPACES: (v: any) => {
    if (v == "") {
      return true;
    }
    return (v && v.trim() == v) || FORM_MESSAGES.BLANK_SPACES_WARNING;
  },
  GREATER_THAN_ZERO: (v: any) => {
    if (!isNaN(parseFloat(v)) && v >= 0) return true;
    return FORM_MESSAGES.GREATER_THAN_ZERO;
  },
  MIN_LENGTH_PASSWORD: (v: string) => v.length >= 8 || MIN_LENGTH_PASSWORD,
  NOT_BLANK_SPACES_VALIDATOR: (v: any) =>
    (v && !!v.trim()) || FORM_MESSAGES.BLANK_SPACES_WARNING,
  NOT_BLANK_SPACES_VALIDATOR_STRING_ARRAY: (v: any) =>
    (typeof v === "string" && !!v.trim()) ||
    (Array.isArray(v) && v.length > 0) ||
    FORM_MESSAGES.BLANK_SPACES_WARNING,
  MIN_VALUE: (v: number): boolean | string => (v && v >= 0) || MINIMUM_VALUE,
  MIN_STEP_VALUE: (v: any) => (v && v >= 1) || MAXIMUM_VALUE,
  MAX_VALUE: (v: number): boolean | string => (v && v >= 1) || MAXIMUM_VALUE,
  MIN_LESS_THAN_MAX: (v: any) => (v && v >= 0) || MINIMUM_VALUE,
  REQUIRED_NUMBER_FIELD: (v: string) => {
    const val = parseInt(v as string);
    if (val >= 0) {
      return true;
    } else return FORM_MESSAGES.REQUIRED_FIELD;
  },
  REQUIRED_NATURAL_NUMBER_FIELD: (v: string) => {
    const val = Number(v as string);
    if (Number.isInteger(val) && val >= 0) {
      return true;
    } else return FORM_MESSAGES.REQUIRED_NATURAL_NUMBER_FIELD;
  },
  INTEGER_AND_DECIMAL_NUMBER_FIELD: (v: any) => {
    return DECIMAL_NUMBER.test(v + "") || FORM_MESSAGES.INVALID_FORMAT;
  },

  SMS_LIMIT: (v: any) => {
    return v.length <= 160 || FORM_MESSAGES.SMS_LIMIT_EXCEEDED.ERROR;
  },
  MAX_SESSION_NAME: (v: any) => {
    return v.length <= 80 || FORM_MESSAGES.SESSION_TEMPLATE_NAME_MAX_LIMIT;
  },

  // HTML Field Validators
  HTML_VALID_STRUCTURE: (v: string) => {
    if (!v) return true;
    try {
      const container = document.createElement("div");
      container.innerHTML = v;
      return (
        container.innerHTML.length > 0 || "El HTML tiene errores de sintaxis"
      );
    } catch (e) {
      return "El HTML tiene errores de sintaxis";
    }
  },
  HTML_HAS_FORM_ELEMENTS: (v: string) => {
    if (!v) return true;
    const container = document.createElement("div");
    container.innerHTML = v;
    const formElements = container.querySelectorAll("input, select, textarea");
    return (
      formElements.length > 0 ||
      "El HTML debe contener al menos un elemento de formulario (input, select o textarea)"
    );
  },
  /**
   * Exactly one logical field: a single text/number input, one select, one textarea,
   * one radio/checkbox group (same `name`), or one `data-html-group` (same value on each control).
   */
  HTML_EXACTLY_ONE_FORM_CONTROL: (v: string) => {
    if (!v) return true;
    const container = document.createElement("div");
    container.innerHTML = v;
    const logical = countLogicalHtmlFormControls(container);
    if (logical === 0) return true;
    if (logical === 1) return true;
    return "Solo se permite un campo de formulario. Puede ser un input, select, textarea, radios o checkboxes con el mismo name, o varios controles con distinto name agrupados con data-html-group=\"un-id\" (mismo valor en todos).";
  },
  HTML_ELEMENTS_HAVE_NAME: (v: string) => {
    if (!v) return true;
    const container = document.createElement("div");
    container.innerHTML = v;
    const formElements = container.querySelectorAll("input, select, textarea");
    if (formElements.length === 0) return true;
    let hasAtLeastOneName = false;
    formElements.forEach(element => {
      if (element.getAttribute("name")) {
        hasAtLeastOneName = true;
      }
    });
    return (
      hasAtLeastOneName ||
      "Los elementos de formulario deben tener el atributo 'name' para capturar valores"
    );
  }
};

export const LOCAL_STORAGE = {
  SEARCHER: "SEARCHER",
  VIEWS: "VIEWS",
  ROLE: "ROLE",
  USER_NAME: "USERNAME",
  COUNTRY: "COUNTRY",
  AVATAR: "AVATAR",
  ADMIN_ROLE: "adminRole",
  DOCTOR_PROFILE: "doctorProfile",
  UID: "UID",
  SEE_SERVICE_DETAIL: "serviceDetails",
  ACCESS: "ACCESS",
  CLIENT_ID: "CLIENT",
  SERVICE_ID: "SERVICE_ID",
  TASK_ID: "TASK_ID"
};

export const VJSF_OPTIONS = {
  icons: {
    info: "mdi-information-outline"
  },
  messages: {
    minItems: "Debe seleccionar al menos {minItems} item"
  },
  locale: "es"
};

export const PHONE_TRANSLATIONS = {
  countrySelectorLabel: "Código país",
  countrySelectorError: "",
  phoneNumberLabel: "Número de teléfono",
  example: "Ejemplo: "
};

export const TYPE_FIELDS = {
  BASIC: "basico",
  LIST: "lista",
  PHONE: "telefono"
};
export const MESSAGE_ERROR = {
  COUNTRY_NOT_FOUND: "No se encontró el país de conexión"
};

export const ENDPOINTS = {
  COUNTRY: "https://ipapi.co/json/"
};

export const RESPONSE_SEARCH_NO_FILTERS = {
  code: 404,
  message: "Ingrese al menos un filtro para la búsqueda"
};

export const ICON_LIST_FIXED = [
  { name: "Persona", value: "mdi-account" },
  { name: "Persona", value: "mdi-account-box" },
  { name: "Persona", value: "mdi-account-box-outline" },
  { name: "Chulo doble", value: "mdi-check-all" },
  { name: "Alarma", value: "mdi-alarm" },
  { name: "Calendario", value: "mdi-calendar" },
  { name: "Corazón", value: "mdi-heart" },
  { name: "Teléfono", value: "mdi-phone" },
  { name: "Carpeta", value: "mdi-folder" }
];

export const FIELD_WIDTHS = [
  { name: "Pequeño", value: "4" },
  { name: "Mediano", value: "6" },
  { name: "Grande", value: "12" }
];

export const REMOVE_MODES = {
  DELETE: "delete",
  DISABLE: "disabled"
};

export const DIALOG = {
  SAVE: "save",
  CANCEL: "cancel"
};

export const SEARCH_FILTER = {
  EMPTY_STATUS: { name: "Estado", value: "", id: "status", active: false },
  EMPTY_NAME: { name: "Nombre", value: "", id: "name", active: true }
};

export const AVAILABILITY_DATA_EVENTS = {
  EDIT_DATA: "editData",
  DELETE_DATA: "deleteData",
  VIEW_DATA: "viewData",
  ASSIGN_SERVICE: "assignService",
  INFO_MODAL_TEMPLATE_CLOSE: "infoModalTemplateClose",
  PROFILE: "profile",
  DISABLE_DATA: "disableData"
};

export const COLLECTIONS_NAME = {
  AVAILABILITY: "Availabilities",
  CAMPUS: "Campus",
  CUPS_PRICE_LEVEL: "CupsPriceLevels",
  DEPENDENCY: "Dependencies",
  FORM_TEMPLATE: "FormTemplates",
  INFO_GROUP: "InfoGroups",
  LIST: "List",
  ROLE: "Roles",
  SERVICE_TEMPLATE: "ServiceTemplates",
  SESSION_TEMPLATE: "SessionTemplate",
  SPACE: "Spaces",
  NOTIFICATION_TEMPLATE: "Dashboard",
  USER: "Users",
  USER_TEMPLATE: "UserTemplates",
  RULE: "GeneralRule",
  TEMPLATES_PDF: "TemplatePdf",
  MULTIMEDIA: "Multimedia",
  ACTION_PLAN: "ActionPlan",
  TASK: "task"
};

export const ESCHEMA_TYPES = {
  STRING: "string",
  ARRAY: "array",
  NUMBER: "number",
  BOOLEAN: "boolean",
  LIST: "lista"
};

export const ENDPOINT_OPTIONS = {
  ALL: "all",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
  POST: "post"
};

export const FORM_FILTERS: Filter[] = [
  {
    mainFilterKey: "form",
    mainFilterName: "Formularios",
    avatar: "mdi-shape-plus",
    initial: true,
    placeholder: "Seleccione los filtros deseados para los Formularios",
    secondaryFilters: [
      {
        name: "Nombre",
        placeholder: "Nombre de Formulario",
        key: "name",
        display: "unique",
        default: true,
        operators: OPERATORS_FILTERS,
        type: "secondaryFilter"
      },
      {
        name: "Categoria",
        placeholder: "Categoria de Formulario",
        key: "category",
        display: "list",
        default: true,
        operators: OPERATORS_FILTERS,
        type: "secondaryFilter",
        options: FORM_CATEGORY.map(item => ({ key: item, name: item }))
      }
    ]
  }
];
export const DATE_NOT_FOUND = {
  format: "--:--"
};

export const SERVICES_ACCESS = {
  PUT: "modificar el servicio"
};

/**
 * Merges ModifVJsfInput / v-jsf emits into the parent form model.
 * Incoming payloads often include `fieldKey: undefined` for keys v-jsf does not own (e.g. HTML);
 * those must not overwrite existing values — plain `{ ...prev, ...next }` would wipe them.
 */
export function mergeFormVjsfModel(
  previous: Record<string, any>,
  next: Record<string, any>
): Record<string, any> {
  const out: Record<string, any> = { ...previous };
  for (const k of Object.keys(next)) {
    if (next[k] !== undefined) {
      out[k] = next[k];
    }
  }
  return out;
}
